import {Timer} from "js-vextensions";
import {minuteInMS} from "web-vcore";
import {EngineConfig_Phases} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_Phases.js";
import {LiveSession, TriggerPackage} from "../../LiveSession.js";
import {EngineSessionComp} from "./EngineSessionComp.js";
import {AlarmsComp, PhaseChange_ExtraMessage} from "./AlarmsComp.js";
import {Phase} from "../../../Server/DB/@Shared/Phase.js";
import {EffectPointerPlayer} from "../../../Server/DB/@Shared/EffectPointerPlayer.js";

export class PhasesComp extends EngineSessionComp<EngineConfig_Phases> {
	constructor(session: LiveSession, config: EngineConfig_Phases) {
		super(session, config, s=>config.enabled, s=>s.IsLocal());
	}

	override GetTriggerPackages() {
		return [
			new TriggerPackage("Phases_GoPhaseTech", this.c.goPhaseTech_triggerSet, this, {}, async triggerInfo=>{
				const alarmsComp = this.s.Comp(AlarmsComp);
				if (alarmsComp.phase == Phase.tech) return; // already in target phase
				alarmsComp.SetPhase(Phase.tech);
			}),
			new TriggerPackage("Phases_GoPhaseDrifting", this.c.goPhaseDrifting_triggerSet, this, {}, async triggerInfo=>{
				const alarmsComp = this.s.Comp(AlarmsComp);
				if (alarmsComp.phase == Phase.drifting) return; // already in target phase
				alarmsComp.SetPhase(Phase.drifting);
			}),
			new TriggerPackage("Phases_GoPhaseDreaming", this.c.goPhaseDreaming_triggerSet, this, {}, async triggerInfo=>{
				const alarmsComp = this.s.Comp(AlarmsComp);
				if (alarmsComp.phase == Phase.dreaming) return; // already in target phase
				alarmsComp.SetPhase(Phase.dreaming);
			}),
			new TriggerPackage("Phases_GoPhaseSolving", this.c.goPhaseSolving_triggerSet, this, {}, async triggerInfo=>{
				const alarmsComp = this.s.Comp(AlarmsComp);
				if (alarmsComp.phase == Phase.solving) return; // already in target phase
				alarmsComp.NotifySolveProgress(this.c.goPhaseSolving_duration * 60, true);
			}),
			new TriggerPackage("Phases_GoPhaseDelving", this.c.goPhaseDelving_triggerSet, this, {}, async triggerInfo=>{
				const alarmsComp = this.s.Comp(AlarmsComp);
				if (alarmsComp.phase == Phase.delving) return; // already in target phase
				alarmsComp.SetPhase(Phase.delving);
			}),
		];
	}

	tech_enterEffectPlayer = new EffectPointerPlayer();
	techExpireTimer!: Timer;
	delving_enterEffectPlayer = new EffectPointerPlayer();

	override OnStart() {
		this.tech_enterEffectPlayer.effectPointer = this.c.tech_enterEffect;
		this.tech_enterEffectPlayer.OnStart();
		this.techExpireTimer = new Timer(1_000_000_000, ()=>{
			const alarmsComp = this.s.Comp(AlarmsComp);
			alarmsComp.SetPhase(this.c.tech_expire_toPhase);
		}, 1).SetContext(this.s.timerContext);

		this.delving_enterEffectPlayer.effectPointer = this.c.delving_enterEffect;
		this.delving_enterEffectPlayer.OnStart();
	}
	override OnStop() {
		this.tech_enterEffectPlayer.Stop();
		this.delving_enterEffectPlayer.Stop();
	}

	override OnInitialDelayCompleted() {
		const alarmsComp = this.s.Comp(AlarmsComp);
		alarmsComp.SetPhase(this.c.phaseAfterInitialDelay);
	}

	override OnStartPhase_Tech(oldPhase: Phase, extraMessage: PhaseChange_ExtraMessage) {
		this.tech_enterEffectPlayer.Play();
		if (this.c.tech_expire_after > 0 && this.c.tech_expire_toPhase != null) {
			this.techExpireTimer.intervalInMS = this.c.tech_expire_after * minuteInMS;
			this.techExpireTimer.Start();
		}
	}
	override OnLeavePhase_Tech(newPhase: Phase, extraMessage: PhaseChange_ExtraMessage) {
		this.techExpireTimer.Stop();
		if (this.c.stopEnterEffectsWhenPhaseIsLeft) this.tech_enterEffectPlayer.Stop();
	}

	override OnStartPhase_Delving(oldPhase: Phase, extraMessage: PhaseChange_ExtraMessage) {
		this.delving_enterEffectPlayer.Play();
	}
	override OnLeavePhase_Delving(newPhase: Phase, extraMessage: PhaseChange_ExtraMessage) {
		if (this.c.stopEnterEffectsWhenPhaseIsLeft) this.delving_enterEffectPlayer.Stop();
	}
}